module.exports = __webpack_public_path__ + "img/fkhover.88558689.svg";